"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var permissionsActions = require("@caddigital/sok-reducers/lib/actions/project/permissions");
var filesActions = require("@caddigital/sok-reducers/lib/actions/files");
var sok_ui_1 = require("@caddigital/sok-ui");
var Types = require("types");
var NavigateConfirmation_1 = require("components/NavigateConfirmation");
var CreateNewFolderModal_1 = require("components/modals/CreateNewFolderModal");
var PropertiesSideMenu_1 = require("./PropertiesSideMenu");
var PermissionListControls_1 = require("./PermissionListControls");
var PermissionList_1 = require("./PermissionList");
var FolderTree_1 = require("components/FolderTree");
var TableRowIcon_1 = require("components/TableRowIcon");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
require("./styles.scss");
var project_1 = require("reducers/selectors/project");
var mapStateToProps = function (state) {
    var _a = (0, project_1.selectAccessDetails)(state), isSuperAdmin = _a.isSuperAdmin, isProjectAdmin = _a.isProjectAdmin, isCustomerAdmin = _a.isCustomerAdmin;
    return {
        isAdminWithMutationPrivileges: isSuperAdmin || isProjectAdmin || isCustomerAdmin,
        preventPageChange: state.project.permissions.changes.length > 0 ||
            (state.project.permissions.modifiedNotifications !== undefined &&
                Object.values(state.project.permissions.modifiedNotifications).length >
                    0),
        folderTree: state.project.permissions.folderTree,
        properties: state.project.permissions.filesFolderProperties,
        metadata: state.files.metadata,
        viewport: state.viewport
    };
};
exports.mapStateToProps = mapStateToProps;
var statePropsExtractable = Types.extractReturnType(exports.mapStateToProps);
var mapDispatchToProps = function (dispatch) { return ({
    clear: function () {
        dispatch(permissionsActions.clearState());
    },
    changeExpand: function (expand, folder) {
        return dispatch(permissionsActions.FolderTreeActions.copyChangeExpand(expand, folder));
    },
    selectItem: function (folder, value) {
        dispatch(permissionsActions.FolderTreeActions.copySelectTargetAction(folder));
        dispatch(permissionsActions.fetchProjectFolderPermissionsRequest(folder.getValue().project, folder.getValue().uuid));
    },
    getContent: function (parent) {
        return dispatch(permissionsActions.FolderTreeActions.fetchTree(parent, ['FOLDER'], 'MINIMAL', false));
    },
    deleteFolderConfirmation: function (items) {
        dispatch(permissionsActions.PropertiesActions.openOverlay('DELETE'));
        dispatch(permissionsActions.PropertiesActions.deleteRequest(items));
    },
    openDialog: function (type) {
        dispatch(permissionsActions.PropertiesActions.openOverlay(type));
    },
    closeDialog: function () {
        dispatch(permissionsActions.PropertiesActions.closeOverlay());
    },
    createNewFolder: function (name, description, parentId) {
        return function (e) {
            e.preventDefault();
            dispatch(permissionsActions.PropertiesActions.saveNewFolderRequest(name, parentId, 'Folder', description));
        };
    },
    fetchSchema: function (folder) {
        dispatch(filesActions.fetchSchema(folder.getValue().id));
    },
    openFilesFolderPropertiesOverlay: function (item) {
        dispatch(permissionsActions.PropertiesActions.openOverlay('EDIT', item.getValue()));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
//#region Types
var dispatchPropsExtractable = Types.extractReturnType(exports.mapDispatchToProps);
//#endregion
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('TeamMembersFolderPermissions'), (0, recompose_1.withState)('warningModal', 'setWarningModal', null), (0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), (0, recompose_1.lifecycle)({
    componentWillUnmount: function () {
        this.props.clear();
    },
    componentDidMount: function () {
        this.props.getContent({
            id: this.props.currentProject.rootFolder,
            name: (0, translation_1.getLocalization)('components/folderTreeNew/rootFolder'),
            uuid: this.props.currentProject.rootFolderIdentifier,
            project: this.props.currentProject.id,
            projectUuid: this.props.currentProject.uuid
        });
        if (this.props.folderTree.data.root !== null) {
            if (this.props.metadata.status === 'STANDBY') {
                this.props.fetchSchema(this.props.folderTree.data.root);
            }
            this.props.selectItem(this.props.folderTree.data.root, true);
        }
    },
    componentDidUpdate: function (prevProps) {
        if (prevProps.folderTree.data.tree !== this.props.folderTree.data.tree &&
            prevProps.folderTree.data.tree !== null &&
            this.props.folderTree.data.tree !== null) {
            var org = prevProps.folderTree.data.tree.getRoot().getValue();
            var next = this.props.folderTree.data.tree.getRoot().getValue();
            if (org.id === next.id) {
                return;
            }
        }
        if (prevProps.folderTree.data.tree !== this.props.folderTree.data.tree &&
            this.props.folderTree.data.root !== null) {
            if (this.props.metadata.status === 'STANDBY') {
                this.props.fetchSchema(this.props.folderTree.data.root);
            }
            this.props.selectItem(this.props.folderTree.data.root, true);
        }
    }
}), recompose_1.pure);
exports.default = enhance(function (props) {
    return (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
        var width = _a.width, height = _a.height;
        return (React.createElement("div", { className: "sok-folder-permissions-content", style: props.viewport.size !== 'DESKTOP' ? {} : { height: height } },
            React.createElement(sok_ui_1.Grid.Row, { className: 'folders-content' },
                React.createElement(sok_ui_1.Grid.Column, { medium: 5 },
                    React.createElement("div", { className: 'folder-controls-container' },
                        React.createElement("div", { className: 'buttons' },
                            props.isAdminWithMutationPrivileges && (React.createElement(sok_ui_1.Button, { className: 'download-matrix-button', icon: React.createElement(sok_ui_1.Icon, { className: 'fa-download' }), size: 'medium', color: 'base-green', externalUrl: "".concat(__APIBASEURL__, "api/project/").concat(props.currentProject.id, "/").concat(props.folderTree.data.tree && props.folderTree.target
                                    ? props.folderTree.target.getValue().id
                                    : props.currentProject.rootFolder, "/permissionMatrix"), text: (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/downloadMatrix') })),
                            props.isAdminWithMutationPrivileges && (React.createElement(sok_ui_1.Button, { className: 'create-folder', icon: React.createElement(sok_ui_1.Icon, { className: 'fa-plus' }), size: 'medium', color: 'base-green', text: (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/newFolder'), onClick: function () {
                                    props.openDialog('NEW_FOLDER');
                                } })))),
                    React.createElement("div", { className: 'folder-tree' },
                        props.folderTree.data.tree === null &&
                            props.folderTree.data.status === 'FETCHING' && (React.createElement("div", { key: 'loading', className: 'loading-spinner' },
                            React.createElement(sok_ui_1.LoadingSpinner, null))),
                        props.folderTree.data.tree !== null &&
                            props.folderTree.status === 'STANDBY' &&
                            props.currentProject && (React.createElement(FolderTree_1.default, { perm: props.currentProject.perm || 0x00, parentIdentifier: props.currentProject.rootFolderIdentifier, tree: props.folderTree.data.tree, showRoot: true, selectItem: props.selectItem, changeExpand: props.changeExpand, getContent: props.getContent, generateNodeProps: function (e) {
                                return props.isAdminWithMutationPrivileges &&
                                    e.node !== props.folderTree.data.root
                                    ? {
                                        buttons: [
                                            React.createElement(TableRowIcon_1.default, { circle: true, className: 'black', icon: 'fa-pen', onClick: function () {
                                                    props.openFilesFolderPropertiesOverlay(e.node);
                                                } }),
                                            React.createElement(TableRowIcon_1.default, { circle: true, className: 'red', icon: 'fa-times', onClick: function () {
                                                    var items = e.node.getValue();
                                                    props.setWarningModal({
                                                        content: [
                                                            (0, translation_1.getLocalization)('userfront/fileList/remove/areYouSure', ['1', props.currentProject.name]),
                                                            (0, translation_1.getLocalization)('userfront/fileList/remove/deleteAllRevisionHistory')
                                                        ],
                                                        action: function () {
                                                            return props.deleteFolderConfirmation([items]);
                                                        }
                                                    });
                                                } })
                                        ]
                                    }
                                    : { buttons: [] };
                            } })))),
                React.createElement(sok_ui_1.Grid.Column, { medium: 7 },
                    React.createElement("div", { className: "permissions-content" },
                        React.createElement("div", { className: "permissions-container" },
                            React.createElement(PermissionListControls_1.default, { currentProject: props.currentProject }),
                            React.createElement("div", { className: "usergroups-permissions" },
                                React.createElement(PermissionList_1.PermissionList, { currentProject: props.currentProject })))))),
            props.properties.mode === 'DELETE' && (React.createElement(sok_ui_1.RequestStatusBox, { key: 'request', status: props.properties.status, statusList: ['STANDBY', 'SAVING', 'SAVED', 'FAILED'] },
                (0, translation_1.getLocalization)('project/FolderPermissionsView/deleteFileDeleting'),
                (0, translation_1.getLocalization)('project/FolderPermissionsView/deleteFileDeleted'),
                (0, translation_1.getLocalization)('project/FolderPermissionsView/deleteFileFailed'))),
            props.currentProject && (React.createElement(CreateNewFolderModal_1.default, { filesFolderProperties: props.properties, isOpen: props.properties.mode === 'NEW_FOLDER', currentFolder: props.folderTree.data.tree && props.folderTree.target
                    ? props.folderTree.target.getValue().id
                    : props.currentProject.rootFolder, closeDialog: props.closeDialog, createNewFolder: props.createNewFolder })),
            props.properties.mode === 'EDIT' &&
                props.metadata.status === 'FETCHED' && (React.createElement(PropertiesSideMenu_1.FilesFolderPropertiesOverlay, { currentProject: props.currentProject, metadata: props.metadata.list })),
            React.createElement(NavigateConfirmation_1.default, { display: props.preventPageChange, firstRow: (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/textNotice1'), secondRow: (0, translation_1.getLocalization)('userfront/project/FolderPermissionsView/textNotice2') }),
            React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.warningModal !== null, close: function () { return props.setWarningModal(null); }, header: (0, translation_1.getLocalization)('genericWarningConfirmationModal/warning'), body: React.createElement(React.Fragment, null,
                    React.createElement(ConfirmDialog_1.Exclamation, null),
                    React.createElement("div", null,
                        React.createElement("div", { className: 'title please-confirm-text' },
                            React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('genericWarningConfirmationModal/pleaseConfirm'))),
                        React.createElement("div", { className: 'text' }, ((props.warningModal && props.warningModal.content) ||
                            []).map(function (x) { return (React.createElement("p", null, x)); })))), footer: React.createElement(React.Fragment, null,
                    React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: function () {
                            if (props.warningModal) {
                                props.warningModal.action();
                                props.setWarningModal(null);
                            }
                        } }),
                    React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () { return props.setWarningModal(null); } })) })));
    }));
});
